module.exports = __webpack_public_path__ + "img/ea_bg4.0ff96437.jpg";